import type { PropsWithChildren } from "react";

import { Modal } from "@similarweb/ui-components";

import { MODAL_STYLES, UPLOAD_MODAL_STYLES } from "./styles";
import type { DealSignalModalStep } from "./types";

type UploadDealSignalsModalProps = PropsWithChildren<{
    readonly isOpen: boolean;
    readonly stepKind: DealSignalModalStep["kind"];
    readonly onRequestClose: VoidFunction;
}>;

export const UploadDealSignalsModal = ({ isOpen, stepKind, onRequestClose, children }: UploadDealSignalsModalProps) => (
    <Modal
        data-automation="signal-recommender-upload-modal"
        isOpen={isOpen}
        customStyles={stepKind === "upload" ? UPLOAD_MODAL_STYLES : MODAL_STYLES}
        onRequestClose={onRequestClose}
    >
        {/* Only the upload step: it has no footer, so without this its only exits are Esc and the
            overlay. The confirm step carries its own Cancel and would just be offering two.

            `Modal.CloseButton` forwards only className/onClick/color, so it cannot carry a
            data-automation of its own; it is addressed by its "clear" icon. */}
        {stepKind === "upload" ? <Modal.CloseButton onClick={onRequestClose} /> : null}
        {children}
    </Modal>
);
